import styled from "styled-components";

export const BankDetailsWrapper = styled.div`
  border-radius: 1em;
  ${'' /* margin: 1em 0; */}
  padding: 1em;
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);

  form {
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.4em;
    column-gap: 0.5em;
    justify-content: space-between;
    align-items: stretch;
  }
  .bank-details-form-input{
    flex: auto;
    width: 47%;
    margin-Top:4px
  } 

  .bank-details-form-title {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 1em;
    margin-bottom: 1em;
  }

  .bank-details-form-img {
    margin-top: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
    width: 100%;
    flex-direction: column;
  }

  .bank-details-form-img img {
    width: 25vmax;
    max-width: 250px;
  }
  
  .bank-name {
    width: 100%;
  }

  @media only screen and (max-width: 768px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    
    .bank-details-form-input {
      width: 100%;
    }
    
    .bank-details-form-input-small {
      max-width: 48%;
    }
  }
  @media only screen and (min-width: 992px) {
    box-shadow : none;
    .bank-details-form-input {
      width: 100%;
    }
  }


`;
